document.addEventListener('DOMContentLoaded', function () {
  // Initialize last count of products in carousel indicators
  let lastProductCount = document.querySelectorAll('.carousel-indicators').length;

  // Function to initialize the carousel indicators for each product
  function initializeCarousel(indicatorsContainer) {
    const dots = indicatorsContainer.querySelectorAll('.indicator-dot');

    if (dots.length === 0) {
      return;
    }

    const sliderId = dots[0]?.getAttribute('aria-controls');
    const slider = document.getElementById(sliderId);

    if (!slider) {
      return;
    }

    const slides = slider.querySelectorAll('.slider__item');

    if (slides.length <= 1) {
      indicatorsContainer.style.display = 'none'; // Hide dots if there's only one slide
      return;
    }

    // Function to update the active dot
    const updateActiveDot = (index) => {
      dots.forEach((dot) => {
        dot.classList.remove('active');
      });

      if (index === 0) {
        dots[0].classList.add('active'); // First dot active
      } else if (index === slides.length - 1) {
        dots[dots.length - 1].classList.add('active'); // Last dot active
      } else {
        dots[1].classList.add('active'); // Middle dot active for all other slides
      }
    };

    // Scroll to the correct slide
    const scrollToSlide = (index) => {
      if (slides[index]) {
        slider.scrollTo({
          left: slides[index].offsetLeft,
          behavior: 'smooth',
        });
        updateActiveDot(index);
      }
    };

    // Add click event listeners to dots
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', function () {
        scrollToSlide(dotIndex);
      });
    });

    // Function to update the active dot based on the slider scroll position
    const updateActiveDotOnScroll = () => {
      const sliderScrollLeft = slider.scrollLeft;
      let closestIndex = 0;
      let minDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - sliderScrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      updateActiveDot(closestIndex);
    };

    // Initialize the first dot as active
    updateActiveDot(0);

    // Add scroll event listener to update active dot when the slider is scrolled
    slider.addEventListener('scroll', updateActiveDotOnScroll);
  }

  // Function to observe and initialize each new carousel indicators asynchronously
  function observeNewCarousels() {
    document.querySelectorAll('.carousel-indicators:not([data-processed])').forEach(indicatorsContainer => {
      initializeCarousel(indicatorsContainer);
      indicatorsContainer.setAttribute('data-processed', 'true'); // Mark as processed to avoid reprocessing
    });
  }

  // MutationObserver to detect newly added carousel indicators
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node or any of its descendants is a carousel indicator
          if (node.classList.contains('carousel-indicators') || node.querySelector('.carousel-indicators')) {
            observeNewCarousels(); // Apply functionality to new carousel indicators
          }
        }
      });
    });
  });

  // Start observing the body for added elements (newly loaded carousels)
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial call to initialize all carousels on page load
  observeNewCarousels();

  // Function to handle the "Load More" button click and observe newly loaded product cards
  function handleLoadMoreClick(event) {
    if (event.target.classList.contains('js-pagination-load-more')) {
      event.preventDefault();

      // Start checking for new products
      const checkInterval = setInterval(() => {
        observeNewCarousels();
        const loadMoreButton = document.querySelector('.js-pagination-load-more');

        // If no more "Load More" button, stop checking
        if (!loadMoreButton) {
          clearInterval(checkInterval); // Stop checking if the last batch is detected
        }
      }, 500); // Check every 500ms until all products are loaded
    }
  }

  // Add click event listener to the document for "Load More" button clicks
  document.addEventListener('click', function (event) {
    handleLoadMoreClick(event);
  });

  // Register the reapply functionality globally
  window.globalReapplyFunctionality = observeNewCarousels;
});